import React, { Component } from "react";
import {
  withStyles,
  Drawer,
  Typography,
  Divider,
  TextField,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
} from "@material-ui/core";
import FileUpload from "../../AddNew/FileUpload";

const drawerWidth = 500;

const styles = (theme) => ({
  root: {
    width: drawerWidth,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "100%",
  },
  textStyle: {
    fontWeight: 400,
  },
  paddingForm: {
    padding: "20px",
  },
});

class CourseAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "",
      agency: "",
      upload_file: [],
      id: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  componentDidMount() {
    if (this.props.edit) {
      this.setState({
        ...this.props.edit_data,
      });
    } else {
      this.setState({
        type: "",
        agency: "",
        upload_file: [],
        id: "",
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.edit !== this.props.edit) {
      if (this.props.edit) {
        this.setState({
          ...this.props.edit_data,
        });
      } else {
        this.setState({
          type: "",
          agency: "",
          upload_file: [],
          id: "",
        });
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const data = this.state;

    if (this.props.edit) {
      this.props.esetData(data);
    } else {
      this.props.setData(data);
      this.setState({
        type: "",
        agency: "",
        upload_file: [],
        id: "",
      });
    }
  }

  onSetFile = (data) => {
    //console.log(data)
    this.setState({
      upload_file: data,
    });
  };

  onDeleteClick(id) {
    this.props.onDeleteClick(id);
  }

  render() {
    let { classes } = this.props;
    return (
      <div>
        <Drawer
          className={classes.root}
          anchor="right"
          open={this.props.show}
          onClose={this.props.handleClose}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <AppBar
            position="static"
            color={this.props.edit ? "secondary" : "primary"}
          >
            <Toolbar>
              <Typography variant="h6" color="inherit">
                {this.props.edit ? "Edit DATA" : "Add New"}
              </Typography>
            </Toolbar>
          </AppBar>

          <div className={classes.paddingForm}>
            <form onSubmit={this.onSubmit}>
              <TextField
                variant="outlined"
                label="Type"
                className={classes.textField}
                type="text"
                name="type"
                autoComplete="current-password"
                margin="normal"
                required
                InputLabelProps={{
                  classes: {
                    root: classes.textStyle,
                  },
                }}
                value={this.state.type}
                onChange={this.onChange}
              />

              <TextField
                variant="outlined"
                label="Agency"
                className={classes.textField}
                type="text"
                name="agency"
                autoComplete="current-password"
                margin="normal"
                required
                InputLabelProps={{
                  classes: {
                    root: classes.textStyle,
                  },
                }}
                value={this.state.agency}
                onChange={this.onChange}
              />
              <br />

              <FileUpload
                dp={this.state.upload_file ? this.state.upload_file : []}
                apikey={this.props.apikey}
                type={`COLLAB_FILE`}
                setDp={this.onSetFile.bind(this)}
              />

              <br />
              <div>
                <Button
                  type="submit"
                  variant="contained"
                  color={this.props.edit ? "secondary" : "primary"}
                  className={classes.button}
                >
                  {this.props.edit ? "Update" : "Submit"}
                </Button>

                {this.props.edit ? (
                  <span>
                    &nbsp;
                    <Button
                      type="button"
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      onClick={this.onDeleteClick.bind(
                        this,
                        this.props.edit_data.id
                      )}
                    >
                      Delete
                    </Button>
                  </span>
                ) : null}
              </div>
            </form>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default withStyles(styles)(CourseAdd);



// WEBPACK FOOTER //
// ./src/Components/Master/Collaborations/CourseAdd.js